// src/components/Gallery.jsx
import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export default function Gallery() {
  const [memories, setMemories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchApproved();
  }, []);

  async function fetchApproved() {
    setLoading(true);
    const { data } = await supabase
      .from("gallery-submissions")
      .select("*")
      .eq("status", "approved")
      .order("created_at", { ascending: false });
    setMemories(data || []);
    setLoading(false);
  }

  return (
    <div style={{ marginTop: 28 }}>
      {loading && <div>Loading gallery...</div>}
      {!loading && memories.length === 0 && (
        <div style={{ color: "#9d7fe6", fontSize: 18 }}>No memories yet. Be the first to share a photo or video!</div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: 32,
          margin: "0 auto",
          maxWidth: 1100,
        }}
      >
        {memories.map((mem) => (
          <div
            key={mem.id}
            style={{
              background: "#f6f2ff",
              borderRadius: 18,
              boxShadow: "0 3px 18px #d5cafd35",
              padding: 16,
              minHeight: 280,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              transition: "box-shadow 0.18s, transform 0.18s",
              position: "relative",
              overflow: "hidden",
            }}
            className="gallery-card"
          >
            {Array.isArray(mem.files) && mem.files.length > 0 ? (
              mem.files.map((file, idx) =>
                file.type === "image" ? (
                  <a
                    key={file.url + idx}
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      marginBottom: 8,
                      width: "100%",
                      borderRadius: 10,
                      overflow: "hidden",
                      boxShadow: "0 1px 5px #d1c4e7"
                    }}
                  >
                    <img
                      src={file.url}
                      alt={file.name}
                      style={{
                        width: "100%",
                        height: 180,
                        objectFit: "cover",
                        borderRadius: 10,
                        transition: "transform 0.18s",
                      }}
                      className="gallery-img"
                    />
                  </a>
                ) : (
                  <a
                    key={file.url + idx}
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      marginBottom: 8,
                      color: "#5522bb",
                      textDecoration: "underline",
                      fontWeight: 600,
                      fontSize: 15
                    }}
                  >
                    {file.name}
                  </a>
                )
              )
            ) : (
              <div style={{ color: "#aaa", marginBottom: 8 }}>No files attached.</div>
            )}

            <div style={{ fontWeight: 700, color: "#443277", fontSize: 19, marginTop: 4 }}>
              {mem.publicName || mem.name || "Anonymous"}
            </div>
            {mem.caption && (
              <div style={{ color: "#6d3dc6", fontSize: 16, marginTop: 2, textAlign: "center" }}>
                {mem.caption}
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Add some basic CSS for hover */}
      <style>{`
        .gallery-card:hover {
          box-shadow: 0 6px 28px #b19eee85;
          transform: translateY(-3px) scale(1.025);
        }
        .gallery-img:hover {
          transform: scale(1.045);
        }
      `}</style>
    </div>
  );
}
